// extracted by mini-css-extract-plugin
export default {"body":"PdfPage_body__Vfed6","columns":"PdfPage_columns__HQJ-8","divider":"PdfPage_divider__75ja+","wrapper":"PdfPage_wrapper__X9C5o"};